import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/new_love_index",
  component: function component() {
    return import("../../../views/new-love/new_love_index.vue");
  },
  name: "new_love_index",
  meta: {
    foot: true,
    title: ""
  }
},
// 新爱心值充值
{
  path: "/new_love_recharge",
  component: function component() {
    return import("@/views/love/love_recharge");
  },
  name: "new_love_recharge",
  meta: {
    title: "爱心值充值",
    foot: true
  }
}, {
  path: "/new_loveWithdrawals",
  component: function component() {
    return import("@/views/love/love_withdrawals");
  },
  name: "new_loveWithdrawals",
  meta: {
    title: "提现",
    foot: true
  }
}, {
  path: "/new_love_list",
  component: function component() {
    return import("@/views/love/love_list");
  },
  name: "new_love_list",
  meta: {
    title: "明细",
    foot: true
  }
}, {
  path: "/new_love_record",
  component: function component() {
    return import("@/views/love/love_record");
  },
  name: "new_love_record",
  meta: {
    title: "爱心值激活记录",
    foot: true
  }
}, {
  path: "/new_love_explain",
  component: function component() {
    return import("@/views/love/love_explain");
  },
  name: "new_love_explain",
  meta: {
    title: "爱心值激活记录",
    foot: true
  }
},
// 爱心值转冻结爱心值
{
  path: "/new-to-freeze",
  component: function component() {
    return import("@/views/love/to-freeze");
  },
  name: "new-to-freeze",
  meta: {
    title: "转换冻结爱心值",
    foot: true
  }
}, {
  path: "/new_love_activation/:id",
  component: function component() {
    return import("@/views/love/love_activation");
  },
  name: "new_love_activation",
  meta: {
    title: "激活详情",
    foot: true
  }
}];